module.exports = __webpack_public_path__ + "img/img_ch_big.52375fbb.png";